"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateOfferModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _client = require("@apollo/client");
var _reactRedux = require("react-redux");
var _selectors = require("../../../../selectors");
var _actions = require("../../../../actions");
var _platform = require("../../../../helpers/platform");
var _ButtonsWrapper = require("./ButtonsWrapper");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ValueWrapper = function ValueWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Flex, {
    flexDirection: "column",
    gap: "--spacing-1",
    justifyContent: "center",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    children: children
  });
};
var getMaskedValue = function getMaskedValue(value) {
  if (value === '') {
    return 'R$ 0,00';
  }
  var numericValue = parseFloat(value) / 100;
  var formatedValue = numericValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatedValue;
};
var getStateMessage = function getStateMessage(value, minValue, maxValue) {
  if (value < minValue) {
    return "O valor m\xEDnimo \xE9 ".concat(getMaskedValue(minValue));
  }
  return "O valor m\xE1ximo \xE9 ".concat(getMaskedValue(maxValue));
};
var getInputState = function getInputState(value, minValue, maxValue) {
  if (value === '' || value === '00') {
    return undefined;
  }
  if (value < minValue || value > maxValue) {
    return 'error';
  }
  return 'success';
};
var CREATE_OFFER = (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nmutation MakeOffer($value: String!, $roomname: String!) {\n  makeOffer(priceInCents: $value, roomname: $roomname) {\n    success\n  }\n}\n"])));
var CreateOfferModal = exports.CreateOfferModal = function CreateOfferModal(_ref2) {
  var _ref2$minValue = _ref2.minValue,
    minValue = _ref2$minValue === void 0 ? 1000 : _ref2$minValue,
    onSuccessfulAction = _ref2.onSuccessfulAction;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getCurrentChat)(state);
    }),
    price = _useSelector.price,
    roomname = _useSelector.roomname;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useMutation = (0, _client.useMutation)(CREATE_OFFER),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    createOfferMutation = _useMutation2[0];
  var maxValue = price * 100;
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _actions.clickSendNegotiationOfferClose)());
    };
  }, []);
  var onSuccessClick = function onSuccessClick() {
    dispatch((0, _actions.clickSendNegotiationOffer)());
    createOfferMutation({
      variables: {
        roomname: roomname,
        value: value
      }
    }).then(function () {
      dispatch((0, _actions.clickSendNegotiationOfferSuccess)());
      onSuccessfulAction === null || onSuccessfulAction === void 0 || onSuccessfulAction('Oferta enviada com sucesso');
    });
    dispatch((0, _actions.closeModal)());
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
    flexDirection: "column",
    gap: "--spacing-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
      children: "Fazer oferta de pre\xE7o"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Text.BodyMedium, {
      children: ["Envie uma oferta de pre\xE7o que deseja pagar. Se o vendedor concordar,", ' ', "o pre\xE7o ser\xE1 editado s\xF3 para voc\xEA que fez a oferta."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
      alignItems: "flex-start",
      flexWrap: "nowrap",
      gap: "--spacing-2",
      marginLeft: "--spacing-1",
      marginRight: "--spacing-1",
      justifyContent: "space-evenly",
      style: {
        height: '110px'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ValueWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
          children: "Pre\xE7o original"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.TextInput, {
          type: "text",
          "aria-label": "Pre\xE7o original",
          disabled: true,
          value: getMaskedValue(maxValue)
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ValueWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
          children: "Sua oferta"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.TextInput, {
          type: "text",
          placeholder: "R$ 0,00",
          "aria-label": "Sua oferta",
          value: getMaskedValue(value),
          onChange: function onChange(e) {
            var newValue = e.target.value.replace(/\D/g, '');
            setValue(newValue);
          },
          state: getInputState(value, minValue, maxValue),
          stateMessage: getStateMessage(value, minValue, maxValue)
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ButtonsWrapper.ButtonsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        variant: "link-button",
        onClick: function onClick() {
          return dispatch((0, _actions.closeModal)());
        },
        fullWidth: _platform.isMsite,
        children: "Cancelar"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        variant: "primary",
        onClick: onSuccessClick,
        disabled: value < minValue || value > maxValue,
        fullWidth: _platform.isMsite,
        children: "Enviar oferta"
      })]
    })]
  });
};
CreateOfferModal.propTypes = {
  minValue: _propTypes.number,
  onSuccessfulAction: _propTypes.func
};